import heic2any from "heic2any";

export const convertHeicToJpeg = (file: any): Promise<File> => new Promise((resolve, reject) => {
  if (file instanceof File) {
    heic2any({ blob: file, toType: "image/jpeg" }).then((res: Blob | Blob[]) => {
      const blob = res instanceof Blob ? res : res[0];
      resolve(new File([blob], `${getFileNameWithoutExtenction(file)}.jpg`));
    }).catch((e: any) => {
      reject(`JPEGへの変換に失敗しました。${e}`);
    })
  } else {
    reject("ファイル以外のオブジェクトをJPEGには変換できません。");
  }
});

export const getFileExtenction = (file: any): string => {
  if (file instanceof File) {
    const str = file.name.split(".").pop();
    return str ? str.toLowerCase() : ""
  }
  return ""
};

const getFileNameWithoutExtenction = (file: any): string => {
  return file instanceof File ? file.name.replace(/\.[^/.]+$/, "") : ""
};
